import {
	getDataFromBoolean, getDataFromImage, getDataFromImageUploader,
	getDataFromList,
	getDataFromTextInput
} from '@/core/item_assistance/receiveDataFromComponents'
import { formatNumberReverse } from '@/core/item_assistance/generatingDifferentialJson'

function multipleAttributeDataCapture (attributeType, attributeName, dataJson, settings) {
	if ($("#" + attributeName + "__area").length) {
		if (attributeType == 'S' || attributeType == 'D') {
			dataCaptureFromMultipleTextInput(attributeName, dataJson, settings)
		}

		if (attributeType == 'N') {
			dataCaptureFromMultipleNumberInput(attributeName, dataJson, settings)
		}

		if (attributeType == 'NM') {
			dataCaptureFromMultipleNmAttribute(attributeName, dataJson, settings)
		}

		if (attributeType == 'L') {
			dataCaptureFromMultipleList(attributeName, dataJson, settings)
		}

		if (attributeType == 'A') {
			dataCaptureFromImageAttribute(attributeName, dataJson, settings)
		}
	} else {
		if (dataJson[attributeName]) {
			delete dataJson[attributeName]
		}
	}
}

function simpleAttributeDataCapture (attributeType, attributeName, dataJson, settings) {
	if ($("#" + attributeName + "__area").length) {
		if (attributeType == 'S' || attributeType == 'D') {
			dataCaptureFromTextInput(attributeName, dataJson, settings)
		}

		if (attributeType == 'N') {
			dataCaptureFromNumberInput(attributeName, dataJson, settings)
		}

		if (attributeType == 'NM') {
			dataCaptureFromNmAttribute(attributeName, dataJson, settings)
		}

		if (attributeType == 'SL') {
			dataCaptureFromSlAttribute(attributeName, dataJson, settings)
		}

		if (attributeType == 'B') {
			dataCaptureFromBoolean(attributeName, dataJson, settings)
		}

		if (attributeType == 'L') {
			dataCaptureFromList(attributeName, dataJson, settings)
		}
	} else {
		if (dataJson[attributeName]) {
			delete dataJson[attributeName]
		}
	}
}

function dataCaptureFromMultipleTextInput (attributeName, dataJson, settings) {
	var i = 0
	dataJson[attributeName] = []

	while (true) {
		var newValue = getDataFromTextInput(attributeName + '__' + i, settings)

		if (newValue == undefined) {
			break
		}

		if (!_.isEmpty(newValue)) {
			dataJson[attributeName].push(newValue)
		}

		i++
	}

	if (_.isEmpty(dataJson[attributeName])) {
		dataJson[attributeName] = null
	}
}

function dataCaptureFromMultipleNumberInput (attributeName, dataJson, settings) {
	var i = 0
	dataJson[attributeName] = []

	while (true) {
		var newValue = getDataFromTextInput(attributeName + '__' + i, settings)

		if (newValue == undefined) {
			break
		}

		if (!_.isEmpty(newValue)) {
			dataJson[attributeName].push(+formatNumberReverse(String(newValue)))
		}

		i++
	}

	if (_.isEmpty(dataJson[attributeName])) {
		dataJson[attributeName] = null
	}
}

function dataCaptureFromMultipleNmAttribute (attributeName, dataJson, settings) {
	var i = 0
	dataJson[attributeName] = []

	while (true) {
		var newValue = getDataFromTextInput(attributeName + '__' + i, settings)
		var newValueFromList = getDataFromList('list__' + attributeName + '__' + i, settings)

		if (newValue === undefined || newValue === '' || newValueFromList === undefined) {
			break
		}

		newValue = formatNumberReverse(String(newValue))

		if (!_.isEmpty(newValue) || (settings && settings['includeEmptyNM'] == true) || (newValue === 0)) {
			var newVal = {}
			newVal['val'] = newValue
			newVal['mu'] = newValueFromList

			dataJson[attributeName].push(newVal)
		}

		i++
	}

	if (_.isEmpty(dataJson[attributeName])) {
		dataJson[attributeName] = null
	}
}

function dataCaptureFromMultipleList (attributeName, dataJson, settings) {
	var i = 0
	dataJson[attributeName] = []

	while (true) {
		var newValueFromList = getDataFromList('list__' + attributeName + '__' + i, settings)

		if (newValueFromList == undefined) {
			break
		}

		if (!_.isEmpty(newValueFromList)) {
			dataJson[attributeName].push(newValueFromList)
		}

		i++
	}

	if (_.isEmpty(dataJson[attributeName])) {
		dataJson[attributeName] = null
	}
}

function dataCaptureFromTextInput (attributeName, dataJson, settings) {
	var newValue = getDataFromTextInput(attributeName, settings)
	if (newValue !== undefined)
		dataJson[attributeName] = (!_.isEmpty(newValue)) ? newValue : null
}

function dataCaptureFromNumberInput (attributeName, dataJson, settings) {
	var newValue = getDataFromTextInput(attributeName, settings)
	if (newValue !== undefined)
		dataJson[attributeName] = (!_.isEmpty(newValue)) ? newValue : null
}

function dataCaptureFromNmAttribute (attributeName, dataJson, settings) {
	var newValue = getDataFromTextInput(attributeName, settings)
	var newValueFromList = getDataFromList('list__' + attributeName, settings)

	newValue = formatNumberReverse(String(newValue))

	dataJson[attributeName] = {}
	if ((!_.isEmpty(newValue) || (settings && settings['includeEmptyNM'] === true) || (newValue === 0)) && newValue !== "") {
		dataJson[attributeName]['val'] = newValue
		dataJson[attributeName]['mu'] = newValueFromList
	} else {
		dataJson[attributeName] = {
			'val': null,
			'mu': newValueFromList
		}
	}
}

function dataCaptureFromSlAttribute (attributeName, dataJson, settings) {
	var i = 0
	dataJson[attributeName] = {}
	var attributeData = null

	if (editableTradeItem.itemData) {
		attributeData = editableTradeItem.itemData[attributeName]
	}

	while (true) {
		// var newValueLang = getDataFromLabel("label__" + attributeName + "__" + i, settings);
		var newValueLang = $('#' + attributeName + '_label__' + i).attr('data-language')
		var newValue = getDataFromTextInput(attributeName + '__' + newValueLang, settings)

		if (newValue === undefined) {
			break
		}

		if (attributeData) {
			if (!newValue && !attributeData[newValueLang]) {

			} else if (newValue === attributeData[newValueLang]) {

			} else if (!newValue && attributeData[newValueLang] === undefined) {

			} else if (newValue !== attributeData[newValueLang]) {
				dataJson[attributeName][newValueLang] = newValue
			}
		} else {
			if (newValue !== '') {
				dataJson[attributeName][newValueLang] = newValue
			}
		}

		i++
	}
	if (_.isEmpty(dataJson[attributeName])) {
		dataJson[attributeName] = null
	}
}

function dataCaptureFromBoolean (attributeName, dataJson, settings) {
	dataJson[attributeName] = getDataFromBoolean(attributeName, settings)
}

function dataCaptureFromList (attributeName, dataJson, settings) {
	var newValue = getDataFromList('list__' + attributeName, settings)
	dataJson[attributeName] = (!_.isEmpty(newValue)) ? newValue : null
}

function dataCaptureFromImageAttribute (attributeName, dataJson, settings) {
	var i = 0
	dataJson[attributeName] = []

	function getImageValues (mode) {
		i = 0

		while (true) {
			var newValue = (mode === 'new') ? getDataFromImageUploader(attributeName + '__image-name__' + i, settings) : getDataFromImage(attributeName + '__image__' + i, settings)
			if (newValue === undefined) {
				break
			}

			if (!_.isEmpty(newValue)) {
				dataJson[attributeName].push((mode === 'new') ? newValue : newValue.split('?id=')[1].split('&')[0])
			}
			i++
		}
	}

	getImageValues('exist')
	getImageValues('new')

	if (_.isEmpty(dataJson[attributeName])) {
		dataJson[attributeName] = null
	}
}

export function attributeDataCapture (attrType, attrName, isMultiple, dataJson, settings) {
	if (isMultiple) {
		multipleAttributeDataCapture(attrType, attrName, dataJson, settings)
	} else {
		simpleAttributeDataCapture(attrType, attrName, dataJson, settings)
	}
}

export function dataCapture (itemStructure, dataJson, settings) {
	_.each(itemStructure, function (attrConfig, attrName) {
		attributeDataCapture(attrConfig['type'], attrName, attrConfig['multiple'], dataJson, settings);
	});
}
